<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="h-100p overflow-y-scroll w-100 vehicle-result-main">
        <div class="custom_container vehicle-result-layout">
            <div class="search-container">
                <!-- Top bar -->
                <div class="search-header">
                    <div class="header-left">
                        <button class="back-button" (click)="onBackButtonClick()">
                            <i class="bi bi-arrow-left"></i>
                            <span>Back</span>
                        </button>
                    </div>
                    <div class="header-center">
                        <h1 class="search-query">{{vehicleDetails?.vehicle_data?.vehicle?.vehicle_no || (selectedSearchResult?.searched_vehicle_no || '-')}}</h1>
                    </div>
                    <!-- <div class="header-right">
                        <div class="search-box">
                            <input class="search-input" type="text" placeholder="Search here" [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange()" />
                        </div>
                    </div> -->
                </div>

                <!-- Loader -->
                <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-main-color">Fetching results, please wait...</p>
                </div>

                <!-- No Results Found -->
                <div *ngIf="!isLoadingResults && noResultsFound" class="container my-4">
                    <div class="text-center py-5">
                        <h3 class="mb-3">No Search Results Found</h3>
                    </div>
                </div>

                <!-- Search Results -->
                <div class="container container--vehicle-result my-3 my-md-4 px-2 px-sm-3" *ngIf="!isLoadingResults && vehicleDetails && !noResultsFound">
                    <div class="main-vehicle-details-wrapper">
                        <!-- <div class="d-flex justify-content-between align-items-center header-section">
                    <div class="text-start pan-header-info">
                        <div class="pan-number-display">{{vehicleDetails?.vehicle_data?.vehicle?.vehicle_no || '-'}}</div>
                        <div class="pan-name-display">{{vehicleDetails?.vehicle_data?.vehicle?.owner?.owner_name || '-'}}</div>
                    </div>
                    <div class="active-badge">
                        <i class="bi bi-car-front"></i>
                        <span>{{vehicleDetails?.vehicle_data?.vehicle?.statusDesc || 'Active'}}</span>
                    </div>
                </div> -->

                        <div class="row g-3 quick-info-row">
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-gender info-card-vehicle">
                                    <div class="info-card-icon">
                                        <i class="bi bi-fuel-pump"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Fuel Type</div>
                                        <h4 class="my-2">{{vehicleDetails?.vehicle_data?.vehicle?.fuel_type || '-'}}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-dob info-card-vehicle">
                                    <div class="info-card-icon">
                                        <i class="bi bi-speedometer2"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Engine</div>
                                        <h4 class="my-2">{{vehicleDetails?.vehicle_data?.vehicle?.cubic_capacity ? (vehicleDetails?.vehicle_data?.vehicle?.cubic_capacity + ' CC') : '-'}}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-aadhaar info-card-vehicle">
                                    <div class="info-card-icon">
                                        <i class="bi bi-car-front"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Vehicle Class</div>
                                        <h4 class="my-2">{{vehicleDetails?.vehicle_data?.vehicle?.vehicleClass || '-'}}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-masked info-card-vehicle">
                                    <div class="info-card-icon">
                                        <i class="bi bi-tag"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Type</div>
                                        <h4 class="my-2">{{vehicleDetails?.vehicle_data?.vehicle?.vehicle_type || '-'}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="details-box-vehicle owner-details-box">
                            <h5 class="details-heading-vehicle"><i class="bi bi-person-vcard"></i>Owner Details</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Owner Name</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.owner?.owner_name || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Father's Name</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.owner?.owner_father_name || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Present Address</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.owner?.present_address || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Permanent Address</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.owner?.permanent_address || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Mobile Number</p>
                                        <p>
                                            <span *ngIf="vehicleDetails?.vehicle_data?.vehicle?.owner?.mobile_number; else noMobile">
                                                <a [href]="'tel:' + vehicleDetails?.vehicle_data?.vehicle?.owner?.mobile_number" class="text-primary">{{vehicleDetails?.vehicle_data?.vehicle?.owner?.mobile_number}}</a>
                                            </span>
                                            <ng-template #noMobile>-</ng-template>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Pincode</p>
                                        <p class="fw-bold">{{vehicleDetails?.vehicle_data?.vehicle?.owner?.pincode || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="details-box-vehicle vehicle-specifications-box mt-3">
                            <h5 class="details-heading-vehicle"><i class="bi bi-car-front"></i>Vehicle Specifications</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Manufacturer</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.manufacturer || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Model</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.model || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Variant</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.variant || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">CC (Cubic Capacity)</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.cubic_capacity ? (vehicleDetails?.vehicle_data?.vehicle?.cubic_capacity + ' CC') : '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Engine Number</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.identification?.engine_number || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Registration Date</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.registration?.regDate || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Seating Capacity</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.seating_capacity || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Chassis Number</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.identification?.chassis_number || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Chassis Last 5</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.identification?.chassis_last5 || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Vehicle Class</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.vehicleClass || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Vehicle Type</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.vehicle_type || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Is Commercial</p>
                                        <p>
                                            <span [class]="vehicleDetails?.vehicle_data?.vehicle?.is_commercial ? 'badge badge-warning' : 'badge badge-success'">
                                                {{vehicleDetails?.vehicle_data?.vehicle?.is_commercial !== null &&
                    vehicleDetails?.vehicle_data?.vehicle?.is_commercial !== undefined ?
                    (vehicleDetails?.vehicle_data?.vehicle?.is_commercial ? 'Yes' : 'No') : '-'}}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Financer</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.financer?.financer_name || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Last Modified Date</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.lmDate || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="details-box-vehicle mt-3">
                            <h5 class="details-heading-vehicle"><i class="bi bi-geo-alt"></i>Registration Authority</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">State Name</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.rto_details?.rtoData?.state_name || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">RTO Code</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.rto_details?.rto_code || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">RTO Name</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.rto_details?.rtoData?.rto_name || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">RTO Location</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.rto_details?.rto_location || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-12 mt-3">
                                    <div class="detail-row">
                                        <p class="detail-label">Registration Authority</p>
                                        <p>{{vehicleDetails?.vehicle_data?.vehicle?.registration?.regAuthority || '-'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row g-3 mt-1 mb-3">
                            <div class="col-md-6">
                                <div class="validation-card insurance-card">
                                    <div class="validation-header-vehicle">
                                        <h5 class="mb-0"><i class="bi bi-shield-check me-1"></i>Insurance</h5>
                                        <div class="valid-badge" [class.invalid-badge]="vehicleDetails?.vehicle_data?.vehicle?.insurance?.insurance_expired">
                                            {{vehicleDetails?.vehicle_data?.vehicle?.insurance?.insurance_expired ? 'EXPIRED' : 'VALID'}}
                                        </div>
                                    </div>
                                    <div class="card-body-content">
                                        <div class="detail-row">
                                            <p class="detail-label">Insurer</p>
                                            <p>{{vehicleDetails?.vehicle_data?.vehicle?.insurance?.insurance_company || '-'}}</p>
                                        </div>
                                        <div class="detail-row mt-3">
                                            <p class="detail-label">Policy Number</p>
                                            <p>{{vehicleDetails?.vehicle_data?.vehicle?.insurance?.insurance_policy || '-'}}</p>
                                        </div>
                                        <div class="detail-row mt-3">
                                            <p class="detail-label">Valid Until</p>
                                            <p class="fw-bold" [ngClass]="vehicleDetails?.vehicle_data?.vehicle?.insurance?.insurance_expired ? 'text-danger' : 'text-success'">
                                                {{vehicleDetails?.vehicle_data?.vehicle?.insurance?.insurance_upto || '-'}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="validation-card pucc-card">
                                    <div class="validation-header-vehicle">
                                        <h5 class="mb-0"><i class="bi bi-patch-check me-1"></i>PUCC</h5>
                                        <div class="valid-badge">VALID</div>
                                    </div>
                                    <div class="card-body-content">
                                        <div class="detail-row">
                                            <p class="detail-label">PUCC Number</p>
                                            <p>{{vehicleDetails?.vehicle_data?.vehicle?.pucc?.pucc_number || '-'}}</p>
                                        </div>
                                        <div class="detail-row mt-3">
                                            <p class="detail-label">Valid Until</p>
                                            <p class="fw-bold text-success">{{vehicleDetails?.vehicle_data?.vehicle?.pucc?.pucc_valid_upto || '-'}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="details-box-vehicle mt-3" *ngIf="selectedSearchResult">
                            <h5 class="details-heading-vehicle">Search Metadata</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Result ID</p>
                                        <p class="text-muted small">{{vehicleDetails?.result_id || '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Vehicle Search ID</p>
                                        <p class="text-muted small">{{vehicleDetails?.vehicle_search_id || '-'}}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Created On</p>
                                        <p>{{vehicleDetails?.created_on ? (vehicleDetails?.created_on | date: 'medium') : '-'}}</p>
                                    </div>
                                    <div class="detail-row mt-3">
                                        <p class="detail-label">Updated On</p>
                                        <p>{{vehicleDetails?.updated_on ? (vehicleDetails?.updated_on | date: 'medium') : '-'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="notes-section mt-3">
                            <div class="notes-header">
                                <i class="bi bi-journal-text"></i>
                                <span>Add Notes</span>
                            </div>
                            <div class="notes-content">
                                <textarea class="note-input" maxlength="300" placeholder="Notes" [(ngModel)]="notes"></textarea>
                                <div class="notes-footer">
                                    <span class="character-count">{{notes.length}}/300</span>
                                    <button type="button" class="update-button" (click)="onUpdateNotesButtonClick()">
                                        Update Notes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>